import React from 'react'

const Cog = () => (
  <svg width='25px' height='25px' viewBox='0 0 64 64'>
    <g id='COG_1_'>
      <g id='COG'>
        <g>
          <path className='app-settings__icon'
            d='M32,20c-6.627,0-12,5.372-12,12c0,6.627,5.372,12,12,12s12-5.373,12-12S38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6
				c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M55.518,25.462c-0.541-1.957-1.326-3.811-2.311-5.536
				c1.121-1.507,4.98-7.143,2.199-9.926l-1.428-1.507c-2.379-2.378-8.455,1.336-9.931,2.298c-1.745-0.989-3.62-1.774-5.6-2.31
				c-0.317-1.887-1.704-8.487-5.619-8.487h-1.567c-3.361,0-5.29,6.824-5.721,8.534c-1.952,0.545-3.801,1.334-5.522,2.32
				C18.661,9.839,12.841,5.816,10,8.656L8.493,9.924c-2.476,2.475,1.638,9.004,2.39,10.147c-0.952,1.698-1.715,3.517-2.241,5.435
				c-1.641,0.262-8.649,1.614-8.649,5.646v1.566c0,3.493,7.349,5.433,8.69,5.759c0.533,1.904,1.3,3.709,2.255,5.394
				c-0.791,1.239-4.745,7.739-2.292,10.194l1.427,1.188c3.229,3.229,9.974-2.075,9.974-2.075l-0.314-0.334
				c1.789,1.058,3.726,1.896,5.773,2.47c0.335,1.379,2.275,8.677,5.755,8.677h1.567c4.566,0,5.697-8.521,5.697-8.521l-0.418-0.013
				c2.069-0.529,4.031-1.325,5.851-2.345c1.426,0.949,7.401,4.688,9.786,2.304l1.587-1.588c3.183-3.183-1.997-9.696-2.142-9.877
				c0.984-1.722,1.773-3.571,2.316-5.525c1.78-0.452,8.483-2.374,8.483-5.707v-1.566C63.988,26.73,56.016,25.533,55.518,25.462z
				M32,50c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C50,41.941,41.941,50,32,50z'
          />
        </g>
      </g>
    </g>
  </svg>
)

export default Cog



// WEBPACK FOOTER //
// ./src/components/AppSettings/Cog.js